const LoginConfig = {
    defaults: {
        navbar: {
          display: false,
          folded: true,
          position: 'left',
        },
        toolbar: {
          display: false,
          style: 'fixed',
        },
        footer: {
          display: false,
          style: 'fixed',
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      }
}
export default LoginConfig;